import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useLocation } from 'react-router-dom';
import { formatReadableAmount } from '../../../../Common/FormatFunctions/FormatAmount';
import { RingLoader } from 'react-spinners';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TableFooter } from "@mui/material";
import PdfPreview from '../../../../Common/PdfPreview_Default';

const apikey = process.env.REACT_APP_API;

const AwakFarmersReport = () => {
    const location = useLocation();
    const Company_Name = sessionStorage.getItem('Company_Name')
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')
    const searchParams = new URLSearchParams(location.search);
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');
    const company_Code = searchParams.get('Company_Code');
    const Year_Code = searchParams.get('Year_Code');
    const Ac_code = searchParams.get('Ac_code');
    const [pdfPreview, setPdfPreview] = useState(null);

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [grandTotals, setGrandTotals] = useState({
        Awak_Qty: 0,
        ReadyQty: 0,
        RejectedQty: 0,
        oldsalerate: 0,
    });

    const API_URL = `${apikey}/CustomerFarmerReport`;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear());
        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(API_URL, {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        Company_Code: company_Code,
                        Year_Code: Year_Code,
                        Ac_code: Ac_code
                    },
                });
                setReportData(response.data);
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report');
            } finally {
                setLoading(false);
            }
        };

        fetchReportData();
    }, [API_URL]);

    useEffect(() => {
        if (reportData.length > 0) {
            const totals = reportData.reduce(
                (acc, item) => {
                    const qty = Number(item.Awak_Qty) || 0;
                    const saleRate = Number(item.oldsalerate) || 0;

                    // Total Awak Qty
                    acc.Awak_Qty += qty;
                    acc.oldsalerate += saleRate;

                    // Ready for sale qty (ONLY when Readyforsale === 'Y')
                    if (item.Readyforsale === "Y") {
                        acc.ReadyQty += qty;
                    }

                    if (
                        item.Readyforsale === "N" &&
                        item.RejectDate &&
                        item.AuctionMark === "N" &&
                        item.sold === "N" &&
                        Number(item.salebilldocno) === 0
                    ) {
                        acc.RejectedQty += qty;
                    }


                    return acc;
                },
                {
                    Awak_Qty: 0,
                    ReadyQty: 0,
                    RejectedQty: 0,
                    oldsalerate: 0,
                }
            );

            setGrandTotals(prev => ({
                ...prev,
                Awak_Qty: totals.Awak_Qty,
                ReadyQty: totals.ReadyQty,
                RejectedQty: totals.RejectedQty,
                oldsalerate: totals.oldsalerate
            }));
        }
    }, [reportData]);


    // const handleExportToExcel = () => {
    //     const wb = XLSX.utils.book_new();
    //     const headers = [
    //         "Awak No", "Date", "Farmer Code", "Farmer Name", "Item Name", "Godown Name", "Quantity", "Sale Rate",
    //     ];

    //     const groupedData = reportData.reduce((acc, item) => {
    //         if (!acc[item.Ac_code]) acc[item.Ac_code] = [];
    //         acc[item.Ac_code].push(item);
    //         return acc;
    //     }, {});

    //     const formattedData = [];
    //     let isFirstFarmer = true;

    //     Object.keys(groupedData).forEach(farmerCode => {
    //         const farmerRows = groupedData[farmerCode];
    //         const farmerName = farmerRows[0].partyName;

    //         // Insert headers only for subsequent farmers
    //         if (!isFirstFarmer) {
    //             formattedData.push({
    //                 "Awak No": "Awak No",
    //                 "Date": "Date",
    //                 "Farmer Code": "Farmer Code",
    //                 "Farmer Name": "Farmer Name",
    //                 "Item Name": "Item Name",
    //                 "Godown Name": "Godown Name",
    //                 "Quantity": "Quantity",
    //                 "Sale Rate": "oldsalerate",
    //             });
    //         }

    //         // Insert data rows
    //         farmerRows.forEach((item, index) => {
    //             formattedData.push({
    //                 "Awak No": item.Doc_No,
    //                 "Date": item.Doc_Date,
    //                 "Farmer Code": item.Ac_code,
    //                 "Farmer Name": index === 0 ? farmerName : "", // show only once
    //                 "Item Name": item.ItemName,
    //                 "Godown Name": item.System_Name_E,
    //                 "Quantity": Number(item.Awak_Qty) || 0,
    //                 "Sale Rate": Number(item.oldsalerate) || 0,
    //             });
    //         });

    //         // Subtotal row
    //         const totalQty = farmerRows.reduce((sum, i) => sum + (Number(i.Awak_Qty) || 0), 0);
    //         formattedData.push({
    //             "Awak No": "",
    //             "Date": "",
    //             "Farmer Code": "",
    //             "Farmer Name": "Total",
    //             "Item Name": "",
    //             "Godown Name": "",
    //             "Quantity": totalQty,
    //             "Sale Rate": "",
    //         });

    //         // Empty row for spacing
    //         formattedData.push({
    //             "Awak No": "",
    //             "Date": "",
    //             "Farmer Code": "",
    //             "Farmer Name": "",
    //             "Item Name": "",
    //             "Godown Name": "",
    //             "Quantity": "",
    //             "Sale Rate": "",
    //         });

    //         isFirstFarmer = false;
    //     });

    //     const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    //     // Set column widths
    //     ws["!cols"] = [
    //         { wch: 12 }, { wch: 15 }, { wch: 12 }, { wch: 25 }, { wch: 25 }, { wch: 25 }, { wch: 12 },
    //     ];

    //     // Bold Farmer Name, headers, and Total row
    //     Object.keys(ws).forEach(cell => {
    //         if (cell.startsWith("!")) return;
    //         const value = ws[cell].v;
    //         if (
    //             (typeof value === "string" && value === "Farmer Name") ||
    //             (typeof value === "string" && value === "Total") ||
    //             headers.includes(value)
    //         ) {
    //             ws[cell].s = { font: { bold: true } };
    //         }
    //     });

    //     XLSX.utils.book_append_sheet(wb, ws, "FarmerReport");
    //     XLSX.writeFile(wb, "FarmerReport.xlsx");
    // };

    const handleExportToExcel = () => {
        const wb = XLSX.utils.book_new();
        const formattedData = [];

        const headers = [
            "Awak No",
            "Item Name",
            "Quantity",
            "Sale Rate",
            "Ready For Sale",
            "Godown Name",
            "Line Name"
        ];

        const groupedData = {};

        reportData.forEach(item => {
            const key = [
                item.Ac_code,
                item.partyName,
                item.FarmerMobile,
                item.SaudaDate,
                Company_Name
            ].join("|");

            if (!groupedData[key]) {
                groupedData[key] = {
                    companyName: Company_Name,
                    farmerName: item.partyName,
                    mobile: item.FarmerMobile,
                    saudaDate: item.SaudaDate,
                    items: []
                };
            }

            groupedData[key].items.push(item);
        });

        let grandTotalQty = 0;
        let grandReadyQty = 0;
        let grandRejectedQty = 0;

        const getReadyStatus = (value) => {
            if (value === "Y") return "Confirm";
            if (value === "N") return "Rejected";
            return "";
        };

        Object.values(groupedData).forEach(group => {

            formattedData.push({});

            formattedData.push({
                "Item Name": "Company Name:",
                "Quantity": group.companyName
            });

            formattedData.push({
                "Item Name": "Farmer Name:",
                "Quantity": group.farmerName
            });

            formattedData.push({
                "Item Name": "Mobile No:",
                "Quantity": group.mobile || ""
            });

            formattedData.push({
                "Item Name": "Sauda Date:",
                "Quantity": formatDate(group.saudaDate) || ""
            });


            formattedData.push({});

            // ===== Table Header =====
            formattedData.push(
                headers.reduce((obj, h) => {
                    obj[h] = h;
                    return obj;
                }, {})
            );

            let totalQty = 0;
            let readyQty = 0;
            let rejectedQty = 0;
            const itemWiseQty = {};

            group.items.forEach(item => {

                const qty = Number(item.Awak_Qty) || 0;
                const itemName = item.ItemName || "";

                totalQty += qty;
                grandTotalQty += qty;

                if (item.Readyforsale === "Y") {
                    readyQty += qty;
                    grandReadyQty += qty;
                }

                if (
                    item.Readyforsale === "N" &&
                    item.RejectDate &&
                    item.AuctionMark === "N" &&
                    item.sold === "N" &&
                    Number(item.salebilldocno) === 0
                ) {
                    rejectedQty += qty;
                    grandRejectedQty += qty;
                }

                if (!itemWiseQty[itemName]) {
                    itemWiseQty[itemName] = 0;
                }
                itemWiseQty[itemName] += qty;

                formattedData.push({
                    "Awak No": item.Doc_No,
                    "Item Name": itemName,
                    "Quantity": qty,
                    "Sale Rate": Number(item.oldsalerate) || 0,
                    "Ready For Sale": getReadyStatus(item.Readyforsale),
                    "Godown Name": item.System_Name_E,
                    "Line Name": item.LineName,
                });
            });

            // ===== Group Totals =====
            formattedData.push({});

            formattedData.push({
                "Item Name": `Quantity Total : ${totalQty}`,
                "Quantity": `Ready For Sale Qty : ${readyQty}`,
                "Sale Rate": `Rejected Qty : ${rejectedQty}`
            });


            const itemWiseTotalLine = Object.keys(itemWiseQty)
                .map(itemName => `${itemName} : ${itemWiseQty[itemName]}`)
                .join("    ");

            formattedData.push({
                "Item Name": itemWiseTotalLine
            });



        });

        // ===== Grand Total =====
        formattedData.push({});
        formattedData.push({
            "Awak No": `Total Quantity : ${grandTotalQty}`,
            "Item Name": `Ready For Sale Qty : ${grandReadyQty}`,
            "Quantity": `Rejected Qty : ${grandRejectedQty}`
        });

        //  IMPORTANT FIX HERE
        const ws = XLSX.utils.json_to_sheet(formattedData, {
            header: headers,
            skipHeader: true
        });

        ws["!cols"] = [
            { wch: 10 },
            { wch: 15 },
            { wch: 15 },
            { wch: 12 },
            { wch: 12 },
            { wch: 15 },
            { wch: 13 }
        ];

        XLSX.utils.book_append_sheet(wb, ws, "FarmerReport");
        XLSX.writeFile(wb, "FarmerReport.xlsx");
    };





    const handlePrint = () => {
        const companyName = Company_Name;
        const fromDateParam = searchParams.get('fromDate');
        const toDateParam = searchParams.get('toDate');

        const doc = generatePDFDocument(companyName,);
        const pdfUrl = URL.createObjectURL(doc);
        const printWindow = window.open(pdfUrl);
        printWindow.onload = function () {
            setTimeout(() => {
                printWindow.print();
            }, 500);
        };
    };

    // const generatePDFDocument = (companyName) => {
    //     const doc = new jsPDF();

    //     // ===== Header =====
    //     doc.setFontSize(12);
    //     doc.setFont(undefined, 'bold');
    //     doc.text(companyName, doc.internal.pageSize.width / 2, 15, { align: 'center' });

    //     doc.setFontSize(10);
    //     doc.setFont(undefined, 'normal');
    //     doc.text(`GSTN : ${Company_GSTNO}`, doc.internal.pageSize.width / 2, 23, { align: 'center' });

    //     doc.setFontSize(12);
    //     doc.setFont(undefined, 'bold');
    //     doc.text("Farmer Report Print", doc.internal.pageSize.width / 2, 32, { align: 'center' });

    //     const startY = 45;

    //     // ===== Group data by Ac_code =====
    //     const groupedData = {};

    //     reportData.forEach(item => {

    //         const groupKey = [
    //             item.Ac_code,
    //             item.partyName,
    //             item.FarmerMobile,
    //             item.SaudaDate,
    //             Company_Name
    //         ].join("|");   // composite key

    //         if (!groupedData[groupKey]) {
    //             groupedData[groupKey] = {
    //                 companyName: Company_Name,
    //                 farmerCode: item.Ac_code,
    //                 farmerName: item.partyName,
    //                 mobile: item.FarmerMobile,
    //                 saudaDate: item.SaudaDate,
    //                 items: []
    //             };
    //         }

    //         groupedData[groupKey].items.push(item);
    //     });


    //     let currentY = startY;

    //     // ===== Loop through each farmer group =====
    //     Object.values(groupedData).forEach(group => {

    //         // Company
    //         doc.setFontSize(6);
    //         doc.setFont(undefined, "bold");
    //         doc.text("Company Name:", 15, currentY);
    //         doc.setFont(undefined, "normal");
    //         doc.text(group.companyName, 40, currentY);
    //         currentY += 4;

    //         // Farmer
    //         doc.setFont(undefined, "bold");
    //         doc.text("Farmer Name:", 15, currentY);
    //         doc.setFont(undefined, "normal");
    //         doc.text(group.farmerName, 40, currentY);
    //         currentY += 4;

    //         // Mobile

    //         doc.setFont(undefined, "bold");
    //         doc.text("Mobile No:", 15, currentY);
    //         doc.setFont(undefined, "normal");
    //         doc.text(group.mobile || "", 40, currentY);
    //         currentY += 4;

    //         // Sauda Date
    //         const sauda = formatDate(group.saudaDate)
    //         doc.setFont(undefined, "bold");
    //         doc.text("Sauda Date:", 15, currentY);
    //         doc.setFont(undefined, "normal");
    //         doc.text(sauda || "", 40, currentY);




    //         currentY += 2; // small gap before the table

    //         const getReadyStatus = (value) => {
    //             if (value === "Y") return "Confirm";
    //             if (value === "N") return "Rejected";
    //             return "";
    //         };
    //         // ---- Farmer rows (keep original table structure) ----
    //         const tableData = [
    //             [
    //                 "Awak No", "Date", "Item Name", "Godown Name","Ready For Sale", "Sale Rate", "Quantity",
    //             ],
    //             ...group.items.map(item => [
    //                 item.Doc_No,
    //                 item.Doc_Date,
    //                 item.ItemName,
    //                 item.System_Name_E,
    //                 getReadyStatus(item.Readyforsale),
    //                 formatReadableAmount(item.Salerate),
    //                 formatReadableAmount(item.Awak_Qty),
    //             ])
    //         ];

    //         doc.autoTable({
    //             head: [tableData[0]],
    //             body: tableData.slice(1),
    //             startY: currentY,
    //             styles: {
    //                 fontSize: 6,
    //                 cellPadding: { top: 0.5, bottom: 0.5, left: 1, right: 1 },
    //                 halign: 'center',
    //             },
    //             headStyles: {
    //                 fillColor: [255, 0, 0],
    //                 textColor: [255, 255, 255],
    //                 fontStyle: 'bold',
    //             },
    //             columnStyles: {
    //                 0: { cellWidth: 15, halign: 'left' },
    //                 1: { cellWidth: 15, halign: 'center' },
    //                 2: { cellWidth: 20, halign: 'center' },
    //                 3: { cellWidth: 45, halign: 'center' },
    //                 4: { cellWidth: 18, halign: 'center' },
    //                 5: { cellWidth: 15, halign: 'right' },
    //                 6: { cellWidth: 25, halign: 'right' },
    //             }
    //         });



    //         currentY = doc.lastAutoTable.finalY + 4;
    //     });

    //     const grandTotalRow = [
    //         { content: '', colSpan: 4 },   // columns 0–4 empty
    //         {
    //             content: 'Total',
    //             styles: {
    //                 halign: 'right',
    //                 fontStyle: 'bold'
    //             }
    //         },

    //         {
    //             content: formatReadableAmount(grandTotals.Salerate),
    //             styles: {
    //                 halign: 'right',
    //                 fontStyle: 'bold'
    //             }
    //         },
    //         {
    //             content: formatReadableAmount(grandTotals.Awak_Qty),
    //             styles: {
    //                 halign: 'right',
    //                 fontStyle: 'bold'
    //             }
    //         },
    //     ];



    //     doc.autoTable({
    //         body: [grandTotalRow],
    //         startY: currentY,
    //         theme: 'grid',
    //         margin: {
    //             right: 42   // 👈 X-axis position (increase = move right)
    //         },
    //         styles: {
    //             fontSize: 6,
    //         },
    //         bodyStyles: {
    //             fillColor: [255, 255, 0],
    //             textColor: [0, 0, 0],
    //             fontStyle: 'bold'
    //         },
    //         columnStyles: {
    //             0: { cellWidth: 15, halign: 'right' } ,// SAME Quantity column
    //             1: { cellWidth: 25, halign: 'right' }
    //         }
    //     });

    const generatePDFDocument = (companyName) => {
        const doc = new jsPDF();

        // ===== Header =====
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(companyName, doc.internal.pageSize.width / 2, 15, { align: 'center' });

        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(`GSTN : ${Company_GSTNO}`, doc.internal.pageSize.width / 2, 23, { align: 'center' });

        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text("Farmer Report Print", doc.internal.pageSize.width / 2, 32, { align: 'center' });

        let currentY = 45;

        // ===== Group data =====
        const groupedData = {};

        reportData.forEach(item => {
            const key = [
                item.Ac_code,
                item.partyName,
                item.FarmerMobile,
                item.SaudaDate,
                Company_Name
            ].join("|");

            if (!groupedData[key]) {
                groupedData[key] = {
                    companyName: Company_Name,
                    farmerName: item.partyName,
                    mobile: item.FarmerMobile,
                    saudaDate: item.SaudaDate,
                    items: []
                };
            }

            groupedData[key].items.push(item);
        });

        const getReadyStatus = (value) => {
            if (value === "Y") return "Confirm";
            if (value === "N") return "Rejected";
            return "";
        };

        // ===== Loop groups =====
        Object.values(groupedData).forEach(group => {

            // ---- Farmer Info ----
            currentY += 6;
            doc.setFontSize(6);
            doc.setFont(undefined, "bold");
            doc.text("Company Name:", 15, currentY);
            doc.setFont(undefined, "normal");
            doc.text(group.companyName, 40, currentY);
            currentY += 4;

            doc.setFont(undefined, "bold");
            doc.text("Farmer Name:", 15, currentY);
            doc.setFont(undefined, "normal");
            doc.text(group.farmerName, 40, currentY);
            currentY += 4;

            doc.setFont(undefined, "bold");
            doc.text("Mobile No:", 15, currentY);
            doc.setFont(undefined, "normal");
            doc.text(group.mobile || "", 40, currentY);
            currentY += 4;

            doc.setFont(undefined, "bold");
            doc.text("Sauda Date:", 15, currentY);
            doc.setFont(undefined, "normal");
            doc.text(formatDate(group.saudaDate) || "", 40, currentY);
            currentY += 4;

            // ---- Calculate totals ----
            let totalQty = 0;
            let readyQty = 0;
            let rejectedQty = 0;

            group.items.forEach(item => {
                const qty = Number(item.Awak_Qty) || 0;
                totalQty += qty;

                if (item.Readyforsale === "Y") {
                    readyQty += qty;
                }

                if (
                    item.Readyforsale === "N" &&
                    item.RejectDate &&
                    item.AuctionMark === "N" &&
                    item.sold === "N" &&
                    Number(item.salebilldocno) === 0
                ) {
                    rejectedQty += qty;
                }
            });

            // ---- Table body ----
            const tableBody = group.items.map(item => [
                item.Doc_No,
                item.Doc_Date,
                item.ItemName,
                item.System_Name_E,
                item.LineName,
                getReadyStatus(item.Readyforsale),
                formatReadableAmount(item.oldsalerate),
                formatReadableAmount(item.Awak_Qty),
            ]);


            // ---- Draw table ----
            doc.autoTable({
                startY: currentY,
                head: [[
                    "Awak No",
                    "Date",
                    "Item Name",
                    "Godown Name",
                    "Line Name",
                    "Ready For Sale",
                    "Sale Rate",
                    "Quantity"
                ]],
                body: tableBody,
                styles: {
                    fontSize: 6,
                    cellPadding: { top: 0.5, bottom: 0.5, left: 1, right: 1 },
                    halign: 'center',
                },
                headStyles: {
                    fillColor: [255, 0, 0],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                },
                columnStyles: {
                    0: { cellWidth: 15, halign: 'left' },
                    1: { cellWidth: 15, halign: 'center' },
                    2: { cellWidth: 20, halign: 'center' },
                    3: { cellWidth: 45, halign: 'center' },
                    4: { cellWidth: 18, halign: 'center' },
                    5: { cellWidth: 18, halign: 'right' },
                    6: { cellWidth: 25, halign: 'right' },
                    7: { cellWidth: 25, halign: 'right' },
                }
            });


            currentY = doc.lastAutoTable.finalY + 3;

            doc.setFontSize(7);
            doc.setFont(undefined, "bold");

            const totalsLine =
                `Quantity Total : ${formatReadableAmount(totalQty || 0)}    ` +
                `Ready For Sale Qty : ${formatReadableAmount(readyQty || 0)}    ` +
                `Rejected Qty : ${formatReadableAmount(rejectedQty || 0)}`;

            doc.text(totalsLine, 15, currentY);

            currentY += 6;




            currentY = doc.lastAutoTable.finalY + 6;
        });


        const grandTotalLine =
            `Total Quantity: ${formatReadableAmount(grandTotals.Awak_Qty)}              ` +
            `Ready For Sale Qty : ${formatReadableAmount(grandTotals.ReadyQty)}              ` +
            `Rejected Qty : ${formatReadableAmount(grandTotals.RejectedQty)}`;

        doc.autoTable({
            startY: currentY,
            theme: "grid",
            styles: {
                fontSize: 6,
                fontStyle: "bold",
                halign: "left"
            },
            body: [
                [
                    {
                        content: grandTotalLine,
                        colSpan: 8
                    }
                ]
            ],
            bodyStyles: {
                fillColor: [255, 255, 204],
                textColor: [0, 0, 0],
                cellPadding: { left: 2, right: 2, top: 1, bottom: 1 }
            }
        });







        const pdfBlob = doc.output('blob');
        setPdfPreview(URL.createObjectURL(pdfBlob));
        return pdfBlob;
    };


    // Group data by Ac_Code
    // const groupByAcCode = (data) => {
    //     const grouped = {};
    //     data.forEach(item => {
    //         const key = item.Ac_code;
    //         if (!grouped[key]) {
    //             grouped[key] = {
    //                 farmerName: item.partyName,
    //                 mobile: item.FarmerMobile,
    //                 items: [],
    //                 totalQty: 0
    //             };
    //         }
    //         grouped[key].items.push(item);
    //         grouped[key].totalQty += Number(item.Awak_Qty) || 0;
    //     });
    //     return grouped;
    // };


    const groupByAcCode = (data) => {
        const grouped = {};

        data.forEach(item => {
            const key = item.Ac_code;
            const qty = Number(item.Awak_Qty) || 0;

            if (!grouped[key]) {
                grouped[key] = {
                    farmerName: item.partyName,
                    mobile: item.FarmerMobile,
                    items: [],
                    totalQty: 0,
                    readyQty: 0,
                    rejectedQty: 0,
                };
            }

            grouped[key].items.push(item);
            grouped[key].totalQty += qty;

            if (item.Readyforsale === "Y") {
                grouped[key].readyQty += qty;
            }


            if (
                item.Readyforsale === "N" &&
                item.RejectDate &&
                item.AuctionMark === "N" &&
                item.sold === "N" &&
                Number(item.salebilldocno) === 0
            ) {
                grouped[key].rejectedQty += qty;
            }
        });

        return grouped;
    };


    const groupedData = groupByAcCode(reportData);




    const groupReportData = (data) => {
        const groupedData = {};
        data.forEach((item) => {
            const key = `${item.Id}`;
            if (!groupedData[key]) {
                groupedData[key] = {
                    items: [],
                    totalQty: 0,
                };
            }
            groupedData[key].items.push(item);
            // groupedData[key].totalQty += parseFloat(item.Bill_Amount) || 0;
        });
        return groupedData;
    };

    const groupedReportData = groupReportData(reportData);

    const safeAmount = (val) => {
        const num = Number(val);
        return isFinite(num) ? num : 0;
    };

    let emptyColsCount = Ac_code ? 4 : 7;

    return (
        <div style={{ marginTop: "10px" }}>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Awak Farmer Report</Typography>
            {Ac_code && reportData.length > 0 && (
                <>
                    <Typography
                        variant="subtitle1"
                        style={{
                            textAlign: 'center',
                            fontSize: "16px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                        }}
                    >
                        Farmer Name: {reportData[0]?.partyName || ""}
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        style={{
                            textAlign: 'center',
                            fontSize: "14px",
                            marginBottom: "10px",
                            fontWeight: "normal",
                        }}
                    >
                        Mobile No: {reportData[0]?.FarmerMobile || ""}
                    </Typography>
                </>

            )}

            {/* <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{fromDate ? FormaDateBalanceSheet(fromDate) : ""} to {toDate ? FormaDateBalanceSheet(toDate) : ""}</Typography> */}

            <div className="mb-3 row align-items-center">
                <div className="col-auto">
                    <button className="btn btn-secondary me-2" onClick={handlePrint}>
                        Print
                    </button>
                    <button className="btn btn-success" onClick={handleExportToExcel}>
                        Export to Excel
                    </button>
                    <button className="btn btn-secondary me-2" onClick={() => generatePDFDocument(Company_Name,)}>
                        Preview PDF
                    </button>
                    {pdfPreview && (
                        <PdfPreview
                            pdfData={pdfPreview}
                            apiData={reportData[0]}
                            label={"SaleRegister"}
                        />
                    )}
                </div>
            </div>

            <div style={{
                maxHeight: 'calc(100vh - 200px)',
                overflow: 'auto',
                position: 'relative',
                border: '1px solid #e0e0e0',
                marginBottom: '60px'
            }} id="reportTable">
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        backgroundColor: 'white'
                    }}>
                        <TableRow>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Awak No</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Sauda Date</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Awak Date</TableCell>
                            <TableCell style={{ textAlign: "right", fontWeight: "bold", backgroundColor: 'white' }}>Quantity</TableCell>
                            {!Ac_code && (
                                <>
                                    <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                                        Farmer Code
                                    </TableCell>
                                    {/* <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                                        Farmer Name
                                    </TableCell> */}
                                </>
                            )}

                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Item Code</TableCell>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Item Name</TableCell>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Godown Name</TableCell>
                            <TableCell style={{ textAlign: "left", fontWeight: "bold", backgroundColor: 'white' }}>Sale Rate</TableCell>
                            <TableCell style={{ textAlign: "center", fontWeight: "bold", backgroundColor: 'white' }}>Ready For Sale</TableCell>
                        </TableRow>
                    </TableHead>



                    <TableBody>

                        {/* List all items for this Ac_Code
                        {Array.isArray(reportData) && reportData.map((item, idx) => (
                            <TableRow
                                key={idx}
                                sx={{
                                    cursor: "pointer",
                                    "&:hover": { backgroundColor: "#fdfd96" },
                                }}
                            >

                                <TableCell>{item.Doc_No}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Doc_Date}</TableCell>
                                <TableCell style={{ textAlign: "right" }}>{formatReadableAmount(item.Awak_Qty)}</TableCell>
                                {!Ac_code && (
                                    <>
                                        <TableCell style={{ textAlign: "center" }}>
                                            {item.Ac_code}
                                        </TableCell>
                                        <TableCell style={{ textAlign: "center" }}>
                                            {item.partyName}
                                        </TableCell>
                                    </>
                                )}
                                <TableCell style={{ textAlign: "center" }}>{item.Item_Code}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.ItemName}</TableCell>
                                <TableCell style={{ textAlign: "left" }}>{item.System_Name_E}</TableCell>
                                <TableCell style={{ textAlign: "center" }}>{item.Readyforsale}</TableCell>
                            </TableRow>
                        ))} */}

                        {!Ac_code && Object.entries(groupedData).map(([acCode, group], gIdx) => (
                            <React.Fragment key={gIdx}>


                                {/* Farmer Name Header */}
                                <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                                    <TableCell colSpan={3} style={{ textAlign: "left" }}>
                                        <span style={{ fontWeight: "bold" }}>
                                            Farmer Name:
                                        </span>{" "}
                                        <span style={{ fontWeight: "normal", fontSize: "16px" }}>
                                            {group.farmerName} (Account Code: {acCode})
                                        </span>
                                        <span style={{ fontWeight: "normal", fontSize: "16px", marginLeft: "20px" }}>
                                            Mobile No: {group.mobile}
                                        </span>
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                </TableRow>



                                {/* Farmer Rows */}
                                {group.items.map((item, idx) => (
                                    <TableRow key={idx} sx={{ "&:hover": { backgroundColor: "#fdfd96" } }}>
                                        <TableCell>{item.Doc_No}</TableCell>
                                        <TableCell align="center">{formatDate(item.SaudaDate)}</TableCell>
                                        <TableCell align="center">{item.Doc_Date}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(item.Awak_Qty)}</TableCell>
                                        <TableCell align="center">{item.Ac_code}</TableCell>
                                        {/* <TableCell align="center">{item.partyName}</TableCell> */}
                                        <TableCell align="center">{item.Item_Code}</TableCell>
                                        <TableCell>{item.ItemName}</TableCell>
                                        <TableCell>{item.System_Name_E}</TableCell>
                                        <TableCell align="left">{formatReadableAmount(Number(item.oldsalerate ?? 0))}</TableCell>
                                        <TableCell align="center">{item.Readyforsale}</TableCell>
                                    </TableRow>
                                ))}

                                {/* Farmer Total */}
                                {/* <TableRow sx={{ backgroundColor: "#fff3cd", fontWeight: "bold" }}>
                                    <TableCell colSpan={1} align="right">
                                        Quantity Total :
                                    </TableCell>

                                    <TableCell colSpan={2} align="right">
                                        {formatReadableAmount(group.totalQty)}
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                </TableRow>


                                <TableRow sx={{ backgroundColor: "#fff3cd", fontWeight: "bold" }}>
                                    <TableCell colSpan={1} align="right">
                                        Ready For Sale Qty :
                                    </TableCell>

                                    <TableCell colSpan={2} align="right">
                                        {formatReadableAmount(group.readyQty)}
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                </TableRow>

                                <TableRow sx={{ backgroundColor: "#fff3cd", fontWeight: "bold" }}>
                                    <TableCell colSpan={1} align="right">
                                        Rejected Qty :
                                    </TableCell>

                                    <TableCell colSpan={2} align="right">
                                        {formatReadableAmount(group.rejectedQty)}
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                        
                                </TableRow> */}

                                {/* Combined Total Row */}
                                <TableRow sx={{ backgroundColor: "#fff3cd", fontWeight: "bold" }}>
                                    <TableCell colSpan={3} align="right">
                                        Quantity Total : {formatReadableAmount(group.totalQty)} &nbsp;&nbsp;&nbsp;
                                        Ready For Sale Qty : {formatReadableAmount(group.readyQty)} &nbsp;&nbsp;&nbsp;
                                        Rejected Qty : {formatReadableAmount(group.rejectedQty)}
                                    </TableCell>

                                    {Array.from({ length: emptyColsCount }).map((_, i) => (
                                        <TableCell key={i} />
                                    ))}
                                </TableRow>



                            </React.Fragment>
                        ))}


                        {/* WHEN Ac_code IS PASSED → NORMAL LIST */}
                        {Ac_code && reportData.map((item, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{item.Doc_No}</TableCell>
                                <TableCell align="center">{formatDate(item.SaudaDate)}</TableCell>
                                <TableCell align="center">{item.Doc_Date}</TableCell>
                                <TableCell align="right">{formatReadableAmount(item.Awak_Qty)}</TableCell>
                                <TableCell align="center">{item.Item_Code}</TableCell>
                                <TableCell>{item.ItemName}</TableCell>
                                <TableCell>{item.System_Name_E}</TableCell>
                                <TableCell align="left"> {formatReadableAmount(Number(item.oldsalerate ?? 0))}</TableCell>
                                <TableCell align="center">{item.Readyforsale}</TableCell>
                            </TableRow>
                        ))}

                        <TableRow sx={{ backgroundColor: '#ffff99', fontWeight: 'bold' }}>
                            {/* Total label */}
                            <TableCell colSpan={1} style={{ textAlign: 'right' }}>
                                Total:
                            </TableCell>

                            {/* Awak Qty */}
                            <TableCell colSpan={2} style={{ textAlign: 'right' }}>
                                {formatReadableAmount(grandTotals.Awak_Qty)}
                            </TableCell>


                            {Array.from({
                                length: Ac_code ? 5 : 7
                            }).map((_, i) => (
                                <TableCell key={i} />
                            ))}
                        </TableRow>

                        <TableRow sx={{ backgroundColor: '#ffffcc', fontWeight: 'bold' }}>
                            <TableCell colSpan={1} style={{ textAlign: 'right' }}>
                                Ready For Sale Qty:
                            </TableCell>
                            <TableCell colSpan={2} style={{ textAlign: 'right' }}>
                                {formatReadableAmount(grandTotals.ReadyQty)}
                            </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#ffffcc', fontWeight: 'bold' }}>
                            <TableCell colSpan={1} style={{ textAlign: 'right' }}>
                                Rejected Qty:
                            </TableCell>
                            <TableCell colSpan={2} style={{ textAlign: 'right' }}>
                                {formatReadableAmount(grandTotals.RejectedQty)}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999
                }}>
                    <RingLoader size={80} />
                </div>
            )}
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default AwakFarmersReport;
